<template>
    <el-dialog
        title="Renseignez le prix du MWh"
        :visible.sync="dialogVisible"
        :before-close="closeModal"
        class="dialog"
    >
        <div>
            <div v-if="noSite">
                <div>
                    Erreur: Aucun site selectionné, retournez à l'accueil.
                </div>
                <el-button
                    @click="$router.push('/')"
                >
                    Accueil
                </el-button>
            </div>
            <div
                v-else
            >
                <el-input 
                    class="price-input"
                    placeholder="Entrez un prix" 
                    type="number" 
                    v-model="price"
                ></el-input>
                <div>
                    Cette valeur sera sauvegardée pour le site {{ site.facility_name }}.
                </div>
            </div>
        </div>
        <div class="buttons-container">
            <el-button
                class="whiteButton"
                @click="closeModal('simple')"
            >
                Annuler
            </el-button>
            <div class="right">
                <el-button
                    type="primary"
                    class="right"
                    :disabled="invalidPrice"
                    @click="savePrice"
                >
                    Valider
                </el-button>
            </div>
        </div>
    </el-dialog>
</template>

<script>
    export default {
        name: 'MwhPriceModal',
        props:{
            dialogVisible:{
                type: Boolean,
                required: false,
                default: false,
            },
            site:{
                type: Object,
                required: false,
                default: () => {return null;},
            }
        },
        emits: ['close'],
        data(){
            return {
                price: 0,
            }
        },
        computed:{
            noSite(){
                return this.site === null;
            },
            invalidPrice(){
                return this.price <= 0;
            }
        },
        methods:{
            closeModal(mode=''){
                this.$emit('close', mode)
            },
            savePrice(){
                let dataToPost = {...this.site}
                dataToPost.mwh_price = this.price
                this.$store.dispatch('patchItem', {
                    item: dataToPost,
                    model: 'site',
                }).then(res => {
                    this.closeModal('advanced')
                })
            }
        }
    }
</script>

<style lang="scss">
.price-input{
    width: 33%;
    input{
        padding: 0;
        border-left: none;
        border-top: none;
        border-right: none;
        border-radius: 0;
        text-align: center;
        // border-bottom-color: @color-1;
        &:focus {
            // border-bottom-color: @color-1 !important;
            border-width: 2px;
        }
    }
}
.buttons-container{
    display: flex;
    gap: 1rem;
    justify-content: end;
    margin-top: 1rem;
}
</style>


// WEBPACK FOOTER //
// src/components/partials/wizard/MwhPriceModal.vue